// Normalize any list-endpoint response into a plain array.
//
// After the backend pagination overhaul, list endpoints return the wrapper
//   { items, totalCount, pageNumber, pageSize, totalPages, orderByLatest }
// while "Lookup" endpoints (and a few legacy ones) still return a plain array
// or a { courses } shape. Reading the wrapper as if it were an array is what
// caused the "X.map is not a function" crashes.
//
// toArray() accepts any of those shapes and is null-safe, so a missing or
// malformed response yields [] instead of throwing inside .map/.filter/.find.
export const toArray = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.courses)) return data.courses;
  return [];
};

export default toArray;
